// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"b2c763e3","453":"9a4134c7","455":"836d0760","977":"8e6298ff"}[chunkId] + ".chunk.js";
};